<template>
    <v-layout column class="post-editor">
        <v-flex xs12>
            <status-bar :action="updatePostAction" :success-duration="null"></status-bar>
        </v-flex>
        <v-flex xs12 class="relative-position">
            <div class="blocked-layover" v-if="saveInProgress"></div>
            <v-form @submit.prevent="submitPost()">
                <v-layout column class="post-editor__content" :class="[ postError ? 'post-editor__error' : '']">
                    <v-flex xs12 v-if="authorImage" pa-2>
                        <v-avatar>
                            <img :src="authorImage" :onerror="imageErrorFallback(authorFallBackImage)">
                        </v-avatar>
                    </v-flex>
                <v-flex xs12 class="post-editor__post-title" v-if="!newPost.parentPostId">
                           <v-text-field
                           :label="communityCommonConstant.post.POST_TITLE" 
                           v-model="newPost.title" solo
                           data-qe-id="`edit_post_title`"                
                           >
                           </v-text-field>
                       </v-flex>
                </v-layout>                
                <v-layout column class="post-editor__content" :class="[ postError ? 'post-editor__error' : '']">
                    <v-flex xs12 px-2>
                        <member-mention-text-area
                            editor-id="memberMentionTextAreaForEdit"
                            data-qe-id="post_edit_mention_text_area"
                            v-if="!newPost.parentPostId"
                            v-model="newPost.body"></member-mention-text-area>
                        <v-textarea
                            v-else
                            id="post_body_input1"
                            data-qe-id="comment_text_area"
                            autofocus
                            outline
                            multi-line
                            scrollable
                            v-model="newPost.body"></v-textarea>
                        <photo-review
                            :remove-photo-handler="removeFile"
                            v-if="allowPostImage && tempFilesForReview.length > 0"
                            :can-add-more="showPhotoUploader"
                            :number-of-files-allowed="communityCommonConstant.post.MAXIMUM_NUMBER_OF_POST_IMAGE"
                            :add-more-photos-handler="handleUploadedFiles"
                            :photo-list="tempFilesForReview"
                            :fileSizeFromOtherSources="alreadyUploadedFilesSize"
                            :maxFileSizeLimit="appCommonConstants.FILE_ATTACHMENT_SIZE_LIMIT">
                        </photo-review>
                        <file-attachment
                            v-if="!newPost.parentPostId"
                            attachmentId="edit_post_file_attachment"
                            :attachmentCallback="handleAttachedFiles"
                            :fileSizeFromOtherSources="postImageFileSize"
                            :maxFileSizeLimit="appCommonConstants.FILE_ATTACHMENT_SIZE_LIMIT"
                            :maxFilesToAttach="appCommonConstants.MAXIMUM_NUMBER_OF_FILE_ATTACHMENTS"
                            :alreadyAttachedFiles="getAlreadyAttachedFiles()"
                            :canDelete="true"
                            :deleteAttachmentHandler="removeAttachment"></file-attachment>
                    </v-flex>
                    <v-flex sm12>
                        <v-layout row class="post__Allow_Comments">
                            <v-flex xs6 class="btns_block pl-2">
                                <photo-uploader
                                    uploader-id="edit_post_photo_uploader_btn"
                                    data-qe-id="edit_post_photo_uploader_btn"
                                    v-if="allowPostImage && showPhotoUploader"
                                    :multiple="true"
                                    :maximum-files="communityCommonConstant.post.MAXIMUM_NUMBER_OF_POST_IMAGE"
                                    :is-type-button="true"
                                    :alreadyAddedImages="tempFilesForReview"
                                    :upload-callback="handleUploadedFiles"
                                    :fileSizeFromOtherSources="alreadyUploadedFilesSize"
                                    :maxFileSizeLimit="appCommonConstants.FILE_ATTACHMENT_SIZE_LIMIT">
                                </photo-uploader>
                            </v-flex>

                            <v-flex xs6 text-xs-right>
                                <v-btn class="secondary_btn small"
                                       @click="closePostEditor(post.id)"
                                       data-qe-id="post-edit_cancel_btn"
                                       :disabled="editFormDisabled">
                                    {{appCommonConstants.CANCEL}}
                                </v-btn>
                                <v-btn class="primary_btn small"
                                       type="submit"
                                       data-qe-id="post-edit_save_btn"
                                       :disabled="editFormDisabled">
                                    {{appCommonConstants.SAVE}}
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>

            </v-form>
            <div class="post_activation_expand_div"></div>
        </v-flex>

    </v-layout>
</template>

<script>
    import { mapMutations, mapActions, mapState } from 'vuex';
    import { storeAction } from '../../../store/storeActions.constant';
    import { storeMutation } from '../../../store/storeMutations.constant';
    import { storeGetters } from '../../../store/storeGetters.constant';
    import FileUpload from 'vue-upload-component';
    import MemberMentionTextArea from "../../CkEditor/MemberMentionTextArea";
    import PhotoReview from "../../PhotoUploader/PhotoReview";
    import { communityCommonConstant } from "../communityCommon.constant";
    import PhotoUploader from "../../PhotoUploader/PhotoUploader";
    import {
        createFormDataForSelectedFiles,
        getFilteredListForUpdatedImages,
        prepareTempImagesForSave,
    } from "../../../common/utils/fileUploader";
    import StatusBar from "../../StatusBar/StatusBar";
    import { appCommonConstants } from "../../appCommon.constants";
    import FileAttachment from "../FileAttachment/FileAttachment";
    import { imageErrorFallback } from "../../../common/utils/utils";


    export default {
        name: 'PostEditor',
        components: {
            StatusBar,
            PhotoUploader,
            PhotoReview,
            FileUpload,
            MemberMentionTextArea,
            FileAttachment,
        },
        props: {
            post: {
                required: true,
            },
            allowPostImage: {
                type: Boolean,
                default: false,
            },
        },
        created() {
            this.newPost.preserveExisitngPostImage = true;
            if (this.post && this.post.parentPostId) {
                this.post.body = this.post.body.replaceAll('<br/>', '\n');
                this.newPost.body = this.post.body;
            }
        },

        data() {
            return {
                communityCommonConstant,
                appCommonConstants,
                files: [],
                newPost: { ...this.post },
                tempFilesForReview: this.post && this.post.postImage && this.post.postImage.length > 0 ? [...this.post.postImage] : [],
                tempAttachmentsForReview: this.post && this.post.postAttachment && this.post.postAttachment.length > 0 ? [...this.post.postAttachment] : [],
                filesFromPhotoUploader: [],
                saveInProgress: false,
                attachments: [],
                postError: false,
            };
        },
        computed: {
            ...mapState("actionState", ["actions"]),
            editFormDisabled() {
                // Don't want to use mapGetters for this. The criteria could change and are component-specific.
                return this.$store.getters[`chapter/${storeGetters.isPostChangePending}`](this.post.id);
            },
            postImageFileSize() {
                let bytes = 0;
                const files = getFilteredListForUpdatedImages(this.tempFilesForReview);
                if (files) {
                    if (files.previouslySavedData) {
                        bytes += this.getSize(files.previouslySavedData);
                    }
                    if (files.newlyAddedData) {
                        bytes += this.getSize(files.newlyAddedData);
                    }
                }
                return bytes;
            },
            alreadyUploadedFilesSize() {
                let bytes = 0;
                const files = getFilteredListForUpdatedImages(this.tempAttachmentsForReview);
                if (files) {
                    if (files.previouslySavedData) {
                        bytes += this.getSize(files.previouslySavedData);
                    }
                    if (files.newlyAddedData) {
                        bytes += this.getSize(files.newlyAddedData);
                    }
                }
                bytes += this.postImageFileSize;
                return bytes;
            },
            imageUrl() {
                /*eslint-disable-next-line no-nested-ternary*/
                return this.files.length && this.files[0].url ? this.files[0].url :
                    this.newPost.postImage && this.newPost.postImage.length > 0 ?
                    this.newPost.postImage[0].url :
                    null;
            },
            authorImage() {
                return this.newPost && this.newPost.authorProfilePicture ?
                    this.newPost.authorProfilePicture :
                    '';
            },
            authorFallBackImage() {
                return this.newPost && this.newPost.authorFallbackProfileImageUrl ?
                    this.newPost.authorFallbackProfileImageUrl :
                    '';
            },
            updatePostAction() {
                return this.actions[storeAction.submitPostEdit || storeAction.uploadFilesToTemporaryStorage];
            },
            showPhotoUploader() {
                return this.tempFilesForReview && (this.tempFilesForReview.length < communityCommonConstant.post.MAXIMUM_NUMBER_OF_POST_IMAGE);
            },
        },
        methods: {
            getSize(files) {
                return files.reduce((size, file) => {
                            return size + file.size;
                        }, 0);
            },
            validatePostBody(body) {
                const div = document.createElement('div');
                div.innerHTML = body;
                const bodyText = div.innerText;
                return bodyText.replace('&nbsp;', '').trim().length > 0;
            },
            imageErrorFallback,
            submitPost() {
                if (this.validatePostBody(this.newPost.body) || (this.tempFilesForReview && this.tempFilesForReview.length > 0) || (this.tempAttachmentsForReview && this.tempAttachmentsForReview.length > 0)) {
                    this.saveInProgress = true;
                    const userMentionPattern = /<a href="(.*?)"/g;
                    const guidPattern = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/i;
                    const matches = this.newPost.body.match(userMentionPattern);
                    this.newPost.mentions = [];
                    if (matches) {
                        matches.forEach((element) => {
                            const obj = {};
                            const [, cid] = element.match(/href="([^"]*)/);
                            if (guidPattern.test(cid)) {
                                obj.PersonId = cid;
                                const newObj = Object.assign({}, obj);
                                this.newPost.mentions.push(newObj);
                            }
                        });
                    }
                    //extracting the recently added images for temp save
                    const fileredImages = getFilteredListForUpdatedImages(this.tempFilesForReview);
                    let imageAcquired = Promise.resolve();
                    //preparing the updated save model with temp image locators before save
                    if (fileredImages.newlyAddedData.length > 0) {
                        /* const tempImageSaved =
                             Promise.resolve(this.uploadFilesToTemporaryStorage(createFormDataForSelectedFiles(fileredImages.newlyAddedData)))*/
                        const selectedFiles = createFormDataForSelectedFiles(fileredImages.newlyAddedData);
                          const  uploadData = {
                              CommunityId: this.newPost.communityId,
                              selectedFiles,
                          };
                        imageAcquired = this.uploadFilesToTemporaryStorage(uploadData)
                            .then((resp) => {
                                if (resp) {
                                    this.newPost.postImage = [...fileredImages.previouslySavedData, ...prepareTempImagesForSave(resp)];
                                }
                            });
                    } else {
                        //if there aren't any newly added images - save normally
                        this.newPost.postImage = fileredImages.previouslySavedData;
                    }
                    let attachmentAcquired = Promise.resolve();
                    const fileredAttachments = getFilteredListForUpdatedImages(this.tempAttachmentsForReview);
                    if (fileredAttachments.newlyAddedData.length > 0) {
                        const selectedFiles = createFormDataForSelectedFiles(fileredAttachments.newlyAddedData);
                          const uploadData = {
                              CommunityId: this.newPost.communityId,
                              selectedFiles,
                          };
                        attachmentAcquired = this.uploadFilesToTemporaryStorage(uploadData)
                            .then((resp) => {
                                if (resp) {
                                    this.newPost.postAttachment = [...fileredAttachments.previouslySavedData, ...prepareTempImagesForSave(resp)];
                                }
                            });
                    } else {
                        //if there aren't any newly added images - save normally
                        this.newPost.postAttachment = fileredAttachments.previouslySavedData;
                    }
                    if (this.post && this.post.parentPostId) {
                        this.newPost.body = this.newPost.body.replace(/↵/g, '\n').replace(/\n/g, "<br/>");
                    }
                    Promise.all([imageAcquired, attachmentAcquired])
                        .then(() => { 
                            if (this.newPost && this.newPost.postImage && this.newPost.postImage.length > 0) {
                            let order = 1;
                            this.newPost.postImage.forEach((image) => {
                                image.order = order;
                                order += 1;                        
                            });
                        }
                        if (this.newPost && this.newPost.postAttachment && this.newPost.postAttachment.length > 0) {
                            let order = 1;
                            this.newPost.postAttachment.forEach((attachment) => {
                                attachment.order = order;
                                order += 1;                        
                            });
                        }
                            this.submitPostEdit(this.newPost); 
                            })
                        .finally(() => {
                            this.saveInProgress = false;
                        });
                } else {
                    this.postError = true;
                    setTimeout(() => {
                        this.postError = false;
                    }, 1000);
                    return false;
                }
            },
            handleUploadedFiles(selectedFiles) {
                if (selectedFiles && selectedFiles.length) {
                    selectedFiles.forEach((file) => {
                        const fileUploaded = this.tempFilesForReview.find(item => item.name === file.name);
                        if (!fileUploaded && this.tempFilesForReview.length < communityCommonConstant.post.MAXIMUM_NUMBER_OF_POST_IMAGE) {
                            this.tempFilesForReview.push(file);
                        }
                    });
                }
            },
            handleAttachedFiles(attachedFiles) {
                if (attachedFiles) {
                    this.tempAttachmentsForReview = [...this.getAlreadyAttachedFiles(), ...attachedFiles];
                }
            },
            removeFile(fileIndex) {
                this.tempFilesForReview.splice(fileIndex, 1);
            },
            removeAttachment(fileIndex) {
                this.tempAttachmentsForReview.splice(fileIndex, 1);
            },
            getAlreadyAttachedFiles() {
                return this.tempAttachmentsForReview.filter(file => !file.hasOwnProperty('file'));
            },
            ...mapActions({
                submitPostEdit: `chapter/${storeAction.submitPostEdit}`,
                uploadFilesToTemporaryStorage: `chapter/${storeAction.uploadFilesToTemporaryStorage}`,
            }),
            ...mapMutations('chapter', [storeMutation.closePostEditor]),
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_responsive.scss';
    @import '../../../common/styles/_commonClasses.scss';

    /* non-global styles here */
    .post-editor {
        border: 1px solid $ypo-medium-gray;
        border-radius: 4px;
        background-color: $white;
        margin-bottom: 15px;
        position: relative;

        .post__avatar {
            background: $ypo-extra-light-gray;
            border-radius: 4px 4px 0 0;
        }

        .post__BodyText {
            margin: 10px;
            width: auto;
        }

        &__image-container {
            position: relative;
            border-top: 1px solid $ypo-medium-gray;
            padding: 10px 0;
        }

        &__image-remove {
            position: absolute !important;
            top: 0;
            right: -3px;
            width: 24px;
            height: 24px;
            background: transparent !important;
            box-shadow: none !important;
            opacity: 0.5;

            &:hover {
                background: $white !important;
                opacity: 0.8;
            }

        }

        &__file-upload {
            margin-left: 10px;
            margin-top: 5px;
            padding: 5px 15px !important;

            * {
                cursor: pointer !important;
            }

            &:hover {
                background-color: $ypo-open-blue-gray !important;
            }
        }

        &__content {
            position: relative;
            z-index: 5;
            background: #fff;
            border-radius: 4px;
        }

        &__error {
            border: 1px $ypo-error-red solid;
        }

    }
</style><style lang="scss">
    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_responsive.scss';

    .post-editor .v-textarea>.v-input__control {
        &>.v-input__slot {
            background-color: $white !important;
            margin-bottom: 0;
            border: none !important;

            & textarea {
                margin: 15px 4px 0 70px !important;
                font-size: 14px;
            }
        }

        &>.v-text-field__details {
            display: none;
        }
    }
    .post-editor {
        &__post-title {
           .v-input {
               position: relative;
               z-index: 9999;
               background: #fff;
               padding: 5px 20px;
               .v-input__control {
                   min-height: 40px;
               }
               .v-input__slot {
                   box-shadow: none !important;
                   margin-bottom: 0;
                   background: inherit !important;
                   padding-left: 0 !important;
                   font-size: 14px;
               }
               .v-label {
                   font-size: 14px;
                   font-weight: 500;
               }
               .v-text-field__details {
                   display: none;
               }
           }
        }  
      }
</style>
